import { API_URL } from '../config/api.config';
import { api } from './api.util';

const API_BASE_URL = API_URL;

export const fetchMaterials = async () => {
  try {
    const response = await api.get('/materials');
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch materials');
  } catch (error) {
    console.error('Error fetching materials:', error);
    return [];
  }
};

export const getMaterialBySlug = async (slug) => {
  try {
    const response = await api.get(`/materials/slug/${slug}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch material');
  } catch (error) {
    console.error('Error getting material by slug:', error);
    const materials = await fetchMaterials();
    const material = materials.find((m) => m.slug === slug);
    if (!material) {
      throw new Error(`Material not found: ${slug}`);
    }
    return material;
  }
};

export const getSubjectByIdForMaterial = async (subjectId) => {
  try {
    const response = await api.get(`/subjects/${subjectId}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch subject');
  } catch (error) {
    console.error('Error getting subject by ID:', error);
    return {
      _id: subjectId,
      title: `Subject ${subjectId?.slice(-4)}`,
      description: 'Subject details not available',
      exams: [],
      materials: []
    };
  }
};

export const fetchSubjectsByMaterial = async (materialSlug) => {
  try {
    const material = await getMaterialBySlug(materialSlug);
    if (!material) {
      throw new Error(`Material not found: ${materialSlug}`);
    }
    const response = await api.get(`/materials/${material._id}/subjects`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch subjects');
  } catch (error) {
    console.error('Error fetching subjects by material:', error);
    return [];
  }
};

export { API_BASE_URL };
